import { reduce } from "et3-type-guards";
import getUserEditProfileStore from "../stores/user-store/edit-profile-store";

export const getUserProfileValue = (existingKey: string) => {
  const data = getUserEditProfileStore().userEditProfileData.get();
  const value = data.find((obj) => {
    return obj.key === existingKey;
  });
  const editeValue = reduce(() => value.value, "");
  return editeValue;
};
